import { Tooltip, IconButton, IconButtonProps, TooltipProps } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { MuiStack } from "./MuiStack";

interface MuiIconButtonProps extends IconButtonProps {
    tooltipTitle?: TooltipProps['title'],
    loadingStatus?: 'loading' | 'idle' | 'error' | (string & {})
}

export const MuiIconButton = (props: MuiIconButtonProps) => {
    const { children, size = 'small', loadingStatus, tooltipTitle, sx, ...other } = props;

    return (
        <Tooltip title={tooltipTitle}>
            {loadingStatus !== "loading"
                ?
                <IconButton
                    {...other}
                    size={size}
                    sx={{ height: 'fit-content', ...sx }}

                >
                    {children}
                </IconButton>
                :
                <MuiStack sx={{ margin: '5px' }}>
                    <CircularProgress size={30} />
                </MuiStack>
            }
        </Tooltip>
    );
}

